export const PORTAL_ELEMENT_MOUNTED = 'pubsub/PORTAL_ELEMENT_MOUNTED';
export const PORTAL_ELEMENT_UNMOUNTED = 'pubsub/PORTAL_ELEMENT_UNMOUNTED';
